// extracted by mini-css-extract-plugin
export var container = "_30-0";
export var icon = "_30-1";